import { render } from "./YamsTemplateConfig.vue?vue&type=template&id=162aafae"
import script from "./YamsTemplateConfig.vue?vue&type=script&lang=js"
export * from "./YamsTemplateConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__